import * as types from '../constants/actionTypes';
import initialState from './initialState';
import findIndex from 'lodash.findindex';
import { sortQuickMessage } from '../functions/utils';

export default function quickMessageReducerAdvance(state = initialState.quickMessagesAdvance, action) {
  switch (action.type) {
    case types.SELECT_QUICK_MESSAGE_SUCCESS: {
      return state.set('selectedQuickMessage', action.data);
    }
    case types.LOAD_QUICK_MESSAGE_REQUEST: {
      return state.set('isLoading', true);
    }
    case types.LOAD_QUICK_MESSAGE_FAILED: {
      return state.set('isLoading', false);
    }
    case types.LOAD_QUICK_MESSAGE_SUCCESS: {
      return state.set('data', sortQuickMessage([...action.quickMessages])).set('isLoading', false);
    }
    case types.ADD_QUICK_MESSAGE_SUCCESS: {
      const quickMessagesAdd = [...state.data, action.quickMessage];
      return state.set('data', sortQuickMessage(quickMessagesAdd));
    }
    case types.UPDATE_QUICK_MESSAGE_SUCCESS: {
      const _index = findIndex(state.data, e => {
        return e.templateId === action.quickMessage.templateId;
      });

      const _quickMessagesUpdate = [...state.data];
      if (_index >= 0) {
        _quickMessagesUpdate[_index] = action.quickMessage;
      }
      return state.set('data', sortQuickMessage([..._quickMessagesUpdate]));
    }
    case types.DELETE_QUICK_MESSAGE_SUCCESS: {
      const quickMessageUpdate = [...state.data].filter(m => m.templateId !== action.quickMessage.templateId);
      return state.set('data', sortQuickMessage([...quickMessageUpdate]));
    }
    case types.USER_LOGOUT_SUCCESS: {
      return initialState.quickMessagesAdvance;
    }
    default:
      return state;
  }
}
